<nav
  [ngClass]="{ 'ml-4 mt-4': !isLargeScreen }"
  data-testid="shared-navigation"
>
  <ul
    [id]="isLargeScreen ? 'appNav' : 'mobileAppNav'"
    class="nav"
    [class.justify-content-center]="isLargeScreen"
  >
    @for (item of navigationData; track $index) {
      @if (item.path !== '#' && item.visible) {
        <li [class.mb-3]="!isLargeScreen">
          <a
            [routerLink]="item.path"
            [queryParams]="item.queryParams"
            (click)="!isLargeScreen && onMobileNavItemClick()"
            class="text-white no-underline"
            [class.mr-1]="isLargeScreen"
            routerLinkActive="active"
            [attr.data-testid]="
              'nav-link-' + item.title.toLowerCase().replace(' ', '-')
            "
            ><i
              [class]="item.icon"
              [class.mr-1]="isLargeScreen"
              [class.mr-2]="!isLargeScreen"
            ></i
            >{{ item.title }}</a
          >
        </li>
      }
      @if (item.path === '#' && item.visible) {
        <li [class.mb-3]="!isLargeScreen">
          <a
            [href]="item.path"
            (click)="!isLargeScreen && onMobileNavItemClick()"
            class="text-white no-underline"
            [class.mr-1]="isLargeScreen"
            routerLinkActive="active"
            [attr.data-testid]="
              'nav-link-' + item.title.toLowerCase().replace(' ', '-')
            "
            ><i
              [class]="item.icon"
              [class.mr-1]="isLargeScreen"
              [class.mr-2]="!isLargeScreen"
            ></i
            >{{ item.title }}</a
          >
        </li>
      }
    }
  </ul>
</nav>
